import { render, staticRenderFns } from "./Seats.vue?vue&type=template&id=4cef2cca&scoped=true"
import script from "./Seats.vue?vue&type=script&lang=js"
export * from "./Seats.vue?vue&type=script&lang=js"
import style0 from "./Seats.vue?vue&type=style&index=0&id=4cef2cca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cef2cca",
  null
  
)

export default component.exports